<template>
  <div class="audience-pacing-navigation">
    <span
      class="back-button"
      :class="{
        'disabled': isDisabledBackButton
      }"
      @click="backSlideHandler"
    >
      <i class="fa fa-chevron-left icon back-icon" />
    </span>
    <span class="slide-number">
      <span>{{ currentSlideIndex + 1 }}</span>
      <span class="slide-index-divider">/</span>
      <span class="total-slides-number">{{ totalSlides }}</span>
    </span>
    <span
      class="next-button"
      :class="{
        'disabled': isDisabledNextButton
      }"
      @click="nextSlideHandler"
    >
      <i class="fa fa-chevron-right icon next-icon" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'AudiencePacingNavigation',
  props: {
    isDisabledBackButton: {
      type: Boolean,
      default: false,
    },
    isDisabledNextButton: {
      type: Boolean,
      default: false,
    },
    presentation: {
      type: Object,
      default: () => ({}),
    },
    currentSlideIndex: {
      type: Number,
      default: 0,
    },
    totalSlides: {
      type: Number,
      default: 0,
    },
    nextSlideHandler: {
      type: Function,
      default: () => {},
    },
    backSlideHandler: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.audience-pacing-navigation {
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);
  width: 100%;
  height: 60px;
  z-index: 10;
  display: flex;
    justify-content: center;
    align-items: center;

  .back-button, .next-button {
    color: rgba(255, 255, 255, 0.8);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.8);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: color 0.3s ease, border-color 0.3s ease;
    .icon {
      font-size: 12px;
    }
    &:not(.disabled):hover {
      color: rgba(255, 255, 255);
      border-color: rgba(255, 255, 255);
      border-width: 1.5px;
    }
    &:not(.disabled):active {
      background-color: rgba(255, 255, 255, 0.2);
    }
    &.disabled {
      color: rgba(255, 255, 255, 0.4);
      border-color: rgba(255, 255, 255, 0.4);
      cursor: not-allowed;
    }
  }

  .slide-number {
    color: white;
    margin-left: 20px;
    margin-right: 20px;
    .slide-index-divider {
      margin-left: 4px;
      margin-right: 4px;
    }
    .total-slides-number {
      color: rgba(255, 255, 255, 0.5);
    }
  }
}
</style>
